(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Clappr"));
	else if(typeof define === 'function' && define.amd)
		define(["Clappr"], factory);
	else if(typeof exports === 'object')
		exports["ClapprStats"] = factory(require("Clappr"));
	else
		root["ClapprStats"] = factory(root["Clappr"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__clappr_core__) {
return 